import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE = "getSLIDERSTableStructure";
export const UPDATE_TABLE_DATA = "getSLIDERSTableData";
export const UPDATE_CREATE_DATA = "getSLIDERCreateData";
export const EXPORT_TABLE_DATA = "getSLIDEREXPORTTABLEDATA";

// mutation types
export const SET_TABLE_STRUCTURE = "setSLIDERSTableStructure";
export const SET_TABLE_DATA = "setSLIDERSTableData";
export const SET_TABLE_FILTER = "setSLIDERSTableFilter";
export const SET_TABLE_PAGE = "setSLIDERSTablePage";
export const SET_TABLE_PERPAGE = "setSLIDERSTablePerPage";
export const SET_TABLE_SORTBY = "setSLIDERSTableSortBy";
export const SET_TABLE_SORTORDER = "setSLIDERSTableSortOrder";
export const SET_CREATE_DATA = "setSLIDERSCreateData";
export const SET_EXPORT_LINK = "setSLIDERExportLink";

const state = {
  table_structure: {},
  table_data: {},
  create_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
  export_link: null,
};

const getters = {
  getSLIDERSTableState(state) {
    return state.table_state;
  },

  getSLIDERSTableHeaders(state) {
    return state.table_structure.columns;
  },

  getSLIDERSTableFilters(state) {
    return state.table_structure.filters;
  },

  getSLIDERSTablePermissions(state) {
    return state.table_structure.permissions;
  },

  getSLIDERSTableData(state) {
    return state.table_data.data;
  },

  getSLIDERSPositionsData(state) {
    return state.create_data.positions;
  },
  getSLIDERSStoresData(state) {
    return state.create_data.stores;
  },
  getSLIDERSTableProperties(state) {
    return state.table_structure.properties;
  },
  getSLIDERSExportUrl(state) {
    return state.export_link;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    return new Promise((resolve) => {
      ApiService.post("/stores/portal/sliders")
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/stores/portal/sliders/datatable", payload)
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);

          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_CREATE_DATA](context, payload) {
    return new Promise((resolve) => {
      ApiService.post("/stores/portal/sliders/create", payload)
        .then(({ data }) => {
          context.commit(SET_CREATE_DATA, data);
          resolve(data);

          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/stores/portal/sliders/export", payload)
        .then(({ data }) => {
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_CREATE_DATA](state, create_data) {
    state.create_data = create_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
